<template>
  <div class="navbar d-none d-sm-flex ;">
    <a href="/" class="a">SIG</a>
    <a href="/scada">SCADA</a>
    <a href="/canales">Res Canales</a>
    <a href="/pozos">Res Pozos</a>
    <a href="/pozos">Dash Cliente 1</a>

    <a href="/pozos">Dash Cliente 2</a>
    <a href="/pozos">Dash Cliente 3</a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.navbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  background-color: #3a7c6e;
  overflow: hidden;

  width: 100%;
}

.navbar a {
  color: #f2f2f2;
  text-align: center;
  padding: 0px 25px;
  text-decoration: none;
  font-size: 15px;
}

.navbar a:hover {
  background-color: #636363;
  color: white;
}

</style>